module.exports = __webpack_public_path__ + "img/1F1F9-1F1F4.8c431e2f.svg";